import { Submission } from 'interfaces';
import { postRequest as post } from '../HttpMethods';
interface CreateSubmissionParams {
  path: string;
  params: any;
  isSubmission: (obj: any) => obj is Submission;
  functionName: string;
}

export const createSubmission = async ({
  path,
  params,
  isSubmission,
  functionName,
}: CreateSubmissionParams): Promise<Submission | null> => {
  try {
    const data = await post('QBilling', path, params);
    const parsedData = await data;
    if (!parsedData || !Object.keys(parsedData).length) {
      return null;
    }
    if (!isSubmission(parsedData)) {
      throw new Error(`${functionName} Failed`);
    }
    return parsedData as Submission;
  } catch (error) {
    throw new Error(`${functionName} Failed`);
  }
};
